import { i18n } from '@/locales';
export const YOGI_DELIVERY = 'YOGI_DELIVERY';
export const BAEMIN_ONE = 'BAEMIN_ONE';
export const O2PLUS_FOR_ADDRESS = 'O2PLUS_FOR_ADDRESS';
// 로드샵
export const SELF = 'SELF';
const orderAgencyType = {
    [YOGI_DELIVERY]: i18n.t('common.yogi_delivery'),
    [BAEMIN_ONE]: i18n.t('common.baemin_one'),
    [O2PLUS_FOR_ADDRESS]: i18n.t('common.o2plus_for_address'),
};
export default orderAgencyType;
